import { getToastState } from '../../../application/shared/toast/selectors/toast-selectors';
import { useAppSelector } from './use-app-selector';

const Toast = () => useAppSelector(getToastState);

export const useSelectors = { Toast };
